import React from "react";
import "../style/pricing.css";
import { useState } from "react";

const PricingSection = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const pricingPlans = [
    {
      id: "short-term",
      icon: "bi bi-person fs-1 text-muted",
      title: "Bamba Plan",
      price: "KES 250,000",
      details: [
        "Anniversaries [birthdays, valentine, gifts, ruracio, wedding,  christmas…] - 65,000",
        "Vacation - 85,000",
        "⁠Eletronics [ mobile phone, TV, Fridge] - 85,000",
      ],
      yearlyDiscount: "1 year savings investment",
      buttonColor: "btn-primary",
    },
    {
      id: "medium-term",
      icon: "bi bi-people fs-1 text-muted",
      title: "Imarika Plan",
      price: "KES 750,000",
      details: [
        "School fees - 125,000",
        "⁠Insurance - 45,000",
        "Emergency fund - 550,000",
        "Other - 30,000"
      ],
      yearlyDiscount: "2 - 5 years savings investment",
      buttonColor: "btn-primary",
    },
    {
      id: "long-term",
      icon: "bi bi-building fs-1 text-muted",
      title: "Milele Plan",
      price: "KES 2,500,000",
      details: [
        "Land - 1,200,000",
        "Car [deposit] - 1,000,000",
        "Others - 300,000"
      ],
      yearlyDiscount: "5+ years savings investment",
      buttonColor: "btn-primary",
    },
  ];

  return (
    <div className="container text-center mt-5 pricing-section">
      <h2 className="fw-bold">Find the personal financial plan that's right for you.</h2>
      <p>Start your plan today and make your financial dreams a reality</p>

      <div className="row">
        {pricingPlans.map((plan) => (
          <div key={plan.id} className="col-md-4">
            <div className="card shadow p-3 mb-5 rounded">
              <div className="card-body">
                <div className="mb-3">
                  
                  <i class={plan.icon}></i>
                </div>
                <h5 className="card-title">{plan.title}</h5>
                <p className="text-muted">{plan.yearlyDiscount}</p>
                <p className="fs-3 fw-bold">{plan.price}</p>
                <button
                  className={`btn ${plan.buttonColor} w-100`}
                  data-bs-toggle="modal"
                  data-bs-target="#pricingModal"
                  onClick={() => setSelectedPlan(plan)}
                >
                  {/* {plan.id === "longterm" ? "Contact Sales" : "Buy Now"} */}
                  view investment
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bootstrap Modal */}
      <div className="modal fade" id="pricingModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{selectedPlan ? selectedPlan.title : "Plan Details"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {selectedPlan ? (
                <ul>
                  {selectedPlan.details.map((detail, index) => (
                    <li key={index}>{detail}</li>
                  ))}
                </ul>
              ) : (
                <p>Loading...</p>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              {/* {selectedPlan && selectedPlan.id !== "longterm" && (
                <button className="btn btn-primary">Proceed to Checkout</button>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PricingSection;

